<template>
  <li
    class="
      layout/flex
      layout/flex:grow
      layout/height:100%
    ">
    <button 
      class="
        @768/layout/padding:left
        @768/layout/padding:right
        $color/black
        color/background
        layout/align:center
        layout/border:3pt
        layout/flex
        layout/flex:grow
        layout/height:100%
        layout/justify:center
        layout/padding:left:clear
        layout/padding:right:clear
        link/cursor
      "
      :class="[
        this.backgroundColor,
        `${floor !== '6' ? 'layout/border:right:clear' : ''}`
      ]"
      style="
        --768--layout--padding--left: 16px;
        --768--layout--padding--right: 16px;
      "
      @click="handleFloorSelection(floor)"
      >
      <p
        :class="[
          this.textColor,
          'typography'
        ]">
        {{ floor }}
      </p>
    </button>
  </li>
</template>

<script>
  export default {
    props: {
      currentFloor: {type: String, required: true, },
      handleFloorSelection: {type: Function, required: true, },
      floor: {type: String, required: true, },
    },
    computed: {
      backgroundColor() {
        return this.currentFloor == this.floor ? '$color/background:black' : '$color/background:eee';
      },
      textColor() {
        return this.currentFloor == this.floor ? '$color/white' : '$color/black';
      },
    }
  }
</script>